import { CSSProperties, useState } from 'react';

import LottieView from 'lottie-react-native';
import { Image, ImageProps } from 'react-native';

import Picture from 'components/picture';
import { buildFileUrl } from 'remote/build-file-url';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { ILoyaltyBadge } from './types';

const defaultEarnedBadge = require('./default-earned-badge.png');
const defaultLockedBadge = require('./default-locked-badge.png');

export const LoyaltyBadgeImage = ({
  badge,
  style,
  showCelebration = false,
}: {
  badge: ILoyaltyBadge;
  style: ImageProps['style'];
  showCelebration?: boolean;
}) => {
  const sanityProjectId = useFlag(LaunchDarklyFlag.SANITY_PROJECT_ID);
  const [showFallbackImage, setShowFallbackImage] = useState(false);

  const { lottie, imageId, imageAlt, earnedAt, name } = badge;
  const lottieUrl = showCelebration && lottie ? buildFileUrl(lottie, sanityProjectId) : undefined;

  if (lottieUrl && !showFallbackImage) {
    return (
      <LottieView
        style={style}
        webStyle={style as CSSProperties}
        source={{ uri: lottieUrl }}
        autoPlay
        loop={false}
        resizeMode="contain"
        onAnimationFailure={() => setShowFallbackImage(true)}
      />
    );
  }

  if (imageAlt) {
    return (
      <Picture
        style={style}
        alt={imageAlt}
        image={{ asset: { _id: imageId } }}
        accessibilityLabel={imageAlt}
        objectFitContain
      />
    );
  }

  return (
    <Image
      style={style}
      source={earnedAt ? defaultEarnedBadge : defaultLockedBadge}
      alt={name}
      accessibilityLabel={name}
    />
  );
};
